// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VerticalList_wrapper__JTotL","list":"VerticalList_list__IuYYX"};